import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Card } from 'ui-components';
import {
  CALC_OUTCOME_TEST_ID,
  RETIREMENT_CALCULATOR_NAMESPACE,
  SavingsProduct,
} from '../../tools/RetirementCalculator.const';
import { RetirementCalculatorOutcomeActions } from './RetirementCalculatorOutcomeActions';
import { RetirementCalculatorOutcomeAssumptions } from './RetirementCalculatorOutcomeAssumptions';
import { RetirementCalculatorOutcomeInvestment } from './RetirementCalculatorOutcomeInvestment';
import { RetirementCalculatorOutcomeResultCardPropsModel } from './RetirementCalculatorOutcome.model';
import { RetirementCalculatorOutcomeResult } from './RetirementCalculatorOutcomeResult';

import useStyles from './RetirementCalculatorOutcome.style';

export const RetirementCalculatorOutcomeResultCard: React.FC<
  RetirementCalculatorOutcomeResultCardPropsModel
> = ({
  projection,
  promotedProduct,
  payoutYears,
  monthlyInvestment,
  maxMonthlyInvestment,
  onMonthlyInvestmentChange,
  learnMoreLabel,
  learnMoreUrl,
  onDownloadSummary,
}) => {
  const c = useStyles({});
  const [t] = useTranslation(RETIREMENT_CALCULATOR_NAMESPACE, { useSuspense: false });

  const productName = t(`savings.products.${promotedProduct}`);
  const productClassName = promotedProduct === SavingsProduct.IKE ? c.ike : c.ikze;
  const pension = projection?.monthlyPension ?? 0;
  const withSavings = projection?.totalMonthlyPayout ?? pension;
  const promotedPayout = projection?.promotedProductPayout ?? 0;

  return (
    <Card
      className={clsx(c.resultCard, productClassName)}
      testId={`${CALC_OUTCOME_TEST_ID}-result`}
    >
      <RetirementCalculatorOutcomeResult
        promotedProduct={promotedProduct}
        productName={productName}
        withSavings={withSavings}
        promotedPayout={promotedPayout}
        total={withSavings + promotedPayout}
        payoutYears={payoutYears}
      />
      <RetirementCalculatorOutcomeInvestment
        monthlyInvestment={monthlyInvestment}
        maxMonthlyInvestment={maxMonthlyInvestment}
        onMonthlyInvestmentChange={onMonthlyInvestmentChange}
      />
      <RetirementCalculatorOutcomeAssumptions />
      <RetirementCalculatorOutcomeActions
        productName={productName}
        learnMoreLabel={learnMoreLabel}
        learnMoreUrl={learnMoreUrl}
        onDownloadSummary={onDownloadSummary}
      />
    </Card>
  );
};
